var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "43", height: "45", viewBox: "0 0 43 45", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21.5 43.844c11.322 0 20.5-9.382 20.5-20.955 0-11.573-9.178-20.956-20.5-20.956S1 11.316 1 22.89s9.178 20.955 20.5 20.955z", fill: "#fff", stroke: "#F19106", strokeWidth: "2", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M29.545 18.057l-18.523-6.101 5.847 19.327 3.454-6.838 9.026 9.377 2.629-2.743L22.99 21.7l6.554-3.644z", fill: "#F19106" })
  );
});